import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'trigger']

  declare readonly dialogTarget: HTMLDialogElement
  declare readonly triggerTarget: HTMLButtonElement

  private headerObserver: ResizeObserver | null = null

  connect(): void {
    const header = this.element.closest<HTMLElement>('.mobile-site-navigation')
    if (!header) return
    const updateHeight = () => {
      document.documentElement.style.setProperty('--app-header-height', `${header.getBoundingClientRect().height}px`)
    }
    updateHeight()
    this.headerObserver = new ResizeObserver(updateHeight)
    this.headerObserver.observe(header)
  }

  disconnect(): void {
    this.headerObserver?.disconnect()
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  open(): void {
    this.dialogTarget.showModal()
    this.triggerTarget.setAttribute('aria-expanded', 'true')
  }

  close(event?: Event): void {
    event?.preventDefault()
    this.dialogTarget.close()
    this.triggerTarget.setAttribute('aria-expanded', 'false')
    this.triggerTarget.focus()
  }

  backdrop(event: MouseEvent): void {
    if (event.target === this.dialogTarget) this.close()
  }

  navigate(event: MouseEvent): void {
    if ((event.target as HTMLElement).closest('a')) this.close()
  }
}
